import 'jquery-touchswipe';
import swipe_detect from 'swipe-detect';
import LineClamp from './line_clamp';
import { disablePageScroll, enablePageScroll } from 'scroll-lock';
// import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

export default {
    columns: ['column-2', 'column-3', 'column-4', 'column-5', 'column-6', 'column-7'],
    column_elements: {},
    values: {},
    table: null,
    animation_duration: '1000',
    //current columns element we're on.
    curr_column: 0,
    modal_opened: false,
    bodyScrollLock: require('body-scroll-lock'),
    animating: false,
    // touch_swipe: require('jquery-touchswipe'),
    init() {
        // this.columns.forEach((column) => {
        // })

        // this.touch_swipe($);
        this.table = document.getElementById('table');

        if(this.table && window.innerWidth < 768) {
            this.addSwipe("column-2");

            this.show_column(this.columns[0]);
            let columns = document.getElementsByClassName('column-2');




            // hiding all except the first column.
            for(let i = 1; i < this.columns.length; i++) {
                this.addSwipe(this.columns[i]);                
            }

            this.get_values();
        }

        let table_holder = document.querySelector('table');

        if(this.table) {
            let table_top = this.table.getBoundingClientRect().top;
            let scroll_event = (e) => {
                console.log("Table scrolling is being fired!");
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                console.log("Table Scroll top: " + table_top + " Current scroll: " + scrollTop + " Modal opened before: " + this.modal_opened)
                // let disableBodyScroll = this.bodyScrollLock.disableBodyScroll;
                // let enableBodyScroll = this.bodyScrollLock.enableBodyScroll;
                if(scrollTop > table_top && this.modal_opened === false && window.innerWidth < 768) {
                    console.log("Inside the table.");
                    let modal = document.getElementById('table-controls-modal')
                    modal.classList.add('active');
                    this.modal_opened = true;
                    // e.preventDefault();
                    disablePageScroll();
    
                    if(modal) {
                        // disableBodyScroll(modal);
                        let exit = modal.querySelector('.modal-close');
                        exit.addEventListener('click', (e) => {
                            modal.classList.remove('active');
                            enablePageScroll();
                            // enableBodyScroll(modal)
                        })
            
                        modal.addEventListener('click', (e) => {
                            e.stopPropagation();
                            if(e.target === modal) {
                                modal.classList.remove('active');
                                enablePageScroll();
                                // enableBodyScroll(modal);
                            }
                        })
                    }

                    return false;
                }

                return true;
            }
            window.addEventListener('scroll', (e) => {
                // if(window.innerWidth < 787) {
                //     window.scroll(0, window.pageYOffset)
                // } makes jittery on iPad.
                let past_table = scroll_event(e);
                if(!past_table) {
                    console.log("Past the table stopping scrolling.");
                    return false;
                }
                // return past_table;
            })
        
        }
    },
    is_ios() {
        return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
          ].includes(navigator.platform)
          // iPad on iOS 13 detection
          || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    },
    addSwipe(class_name) {
        var that = this;
        let classes = document.getElementsByClassName(class_name);
        if(classes.length > 0) {
            for(let i = 0; i < classes.length; i++) {
                swipe_detect(classes[i], async function(direction) {
                    //if no animation is currently taking place.
                    if(that.animating === false) {
                        let modals = document.getElementsByClassName("info-modal");
                        console.log(direction);
                        if(direction === 'right') {
                            let index = that.columns.indexOf(class_name);
                            if(that.columns[that.curr_column + 1]) {
                                that.curr_column++;
                                that.update_display(class_name, that.curr_column, 400, true);
                            } else {
                                that.curr_column = 0;
                                that.update_display(class_name, that.curr_column, 400, true);
                            }

                            for(let j = 0; j < modals.length; j++) {
                                let modal = modals[j];
                                if(modal.classList.contains('info-modal--active')) {
                                    modal.classList.remove('info-modal--active');
                                    that.enable_scrolling();
                                }
                            }
                        }

                        if(direction === "left") {
                            let index = that.columns.indexOf(class_name, direction);
                            if(that.columns[that.curr_column - 1]) {
                                that.curr_column--;
                                that.update_display(class_name, that.curr_column, 400, false);
                            } else {
                                that.curr_column = that.columns.length - 1;
                                that.update_display(class_name, that.curr_column, 400, false);
                            }

                            for(let j = 0; j < modals.length; j++) {
                                let modal = modals[j];
                                if(modal.classList.contains('info-modal--active')) {
                                    modal.classList.remove('info-modal--active');
                                    that.enable_scrolling();
                                }
                            }
                        }
                    }
                }, 25);
            }
        }
    },

    //getting the initial values for each column.
    get_values(selected_column = undefined) {
        this.values = {};
        // this.curr_column = 0;
        let column_to_display = (selected_column) ? this.get_index_from_column(selected_column) : 0;
        this.curr_column = column_to_display
        for(let i = 0; i < this.columns.length; i++) {
            let columns = this.table.getElementsByClassName(this.columns[i]);
            this.values[this.columns[i]] = [];
            for(let j = 0; j < columns.length; j++) {
                this.get_column_value(columns[j], this.columns[i]);
                let column_div = columns[j].getElementsByTagName('div')[0];
                this.values[this.columns[i]].push(column_div);
                if(this.columns[column_to_display] !== this.columns[i]) {
                    columns[j].style.display = "none";
                } else {
                    columns[j].removeAttribute('style')
                }

                columns[j].classList.remove("animate__animate", "animate__fadeInRight", "animate__fadeOutRight", "animate__fadeOutLeft");
            }

            // this.values[this.columns[i]] = columns;
        }


        
        // this.update_display(column_to_display)

        console.log('Got values: ', this.values)
    },
    /**
     * Gets the index of the column to display.
     * @param {string} column_name The name of the column to get an  index for.
     * @returns {number} Index to display.
     */
    get_index_from_column(column_name) {
        switch(column_name) {
            //do nothing if local authority
            case 'Local authority' :
                return 0;
            case 'Ofsted rating' :
                return 0;
            case 'GCSEs' :
                return 1;
            case 'Destinations' :
                return 2;
            case 'Attendance' :
                return 3;
            case 'Qualified teachers' :
                return 4;
            case 'Confidence rating' :
                return 5;
            default :
                return 0;
        }

    },
    /**
     * Showing a new column based.
     * @param {string} class_to_hide class name of the element we no longer wish to show.
     * @param {number} to_show_index index of this.columns that we would like to show next.
     * @param {number} animation_duration desired duration of animation (ms).
     * @param {boolean} go_right whether we should animate left or right (right by default)
     */
    async update_display(class_to_hide, to_show_index, animation_duration, go_right) {
        /**Ensuring not mid through animation already */
        if(!document.getElementsByClassName(class_to_hide)[0].classList.contains('animate__animated') && 
           !document.getElementsByClassName(this.columns[to_show_index])[0].classList.contains('animate__animated')) {
            //informing the swiper we are peforming an animation
            this.animating = true;
            
            /** Hiding the selected elements */
            let previous_elements = document.getElementsByClassName(class_to_hide);
            //going through previous elements and adding fade out animation.
            if(previous_elements.length > 0) {
                for(let i = 0; i < previous_elements.length; i++) {
                    let previous_element = previous_elements[i];

                    //removing the entry animations
                    previous_element.classList.remove("animate__animated", "animate__fadeInRight");

                    //adding leave animation
                    previous_element.classList.add("animate__animated", (go_right === true) ? 'animate__fadeOutRight' : 'animate__fadeOutLeft');
                    previous_element.style.cssText = `animation-duration: ${animation_duration}ms;`;
                }
            }

            
            /** Showing the selected elements after hiding animation is complete.
             * Also hides the previous elements as the animation should be done.
             */
            setTimeout(() => {
                //going through previous elements and hiding them.
                if(previous_elements.length > 0) {
                    for(let i = 0; i < previous_elements.length; i++) {
                        let previous_element = previous_elements[i];

                        previous_element.removeAttribute('style');
                        previous_element.classList.remove("animate__animated", 'animate__fadeOutRight', 'animate__fadeOutLeft');
                        previous_element.style.display = "none";
                    }
                }

                let selected_column = this.columns[to_show_index];
                let elements = document.getElementsByClassName(selected_column);

                setTimeout(() => {
                    //going through list of elements we wish to show.
                    if(elements.length > 0) {
                        for(let i = 0; i < elements.length; i++) {
                            let el = elements[i];
    
                            //removing previous animations that may exist.
                            el.classList.remove("animate__animated", "animate__fadeOutRight", "animate__fadeOutLeft");
                            el.removeAttribute('style');
    
                            //adding new animation
                            el.classList.add('animate__animated', 'animate__fadeInRight');
                            el.style.cssText = `animation-duration: ${animation_duration}ms;`;
                        }
                    }
                }, 50);
                

                /** Waiting for the current element animation to also finish. */
                setTimeout(() => {
                    //going through list of elements we wish to remove animation for.
                    if(elements.length > 0) {
                        for(let i = 0; i < elements.length; i++) {
                            let el = elements[i];
                            //removing animation
                            el.classList.remove('animate__animated', 'animate__fadeInRight');
                            el.removeAttribute('style');
                        }
                    }

                    this.animating = false;
                }, animation_duration + 50)
            }, animation_duration);
        }

        //animation should be finished.
        LineClamp.init();

    },
    get_column_value(column, class_name) {

        let column_div = column.getElementsByTagName('div')[0];
    },
    hide_column(class_name, direction) {
        console.log("Hiding " + class_name);
        let columns = document.getElementsByClassName(class_name);
        if(columns.length > 0) {
            for(let i = 0; i < columns.length; i++) { 
                let animation_name = (direction === "right") ? "right_fade" : "left_fade";
                let column_div = columns[i].getElementsByTagName('div')[0];
                column_div.style.animationDuration = null;
                column_div.style.animationFillMode = null;
                column_div.classList.add(animation_name);
            }
        }
    },
    update_column() {
        let main_column = document.getElementsByClassName('column-2');
        let new_column = this.values[this.columns[this.curr_column]];
        // console.log("The new column is: " + new_column);
        for(let i = 0; i < main_column.length; i++) {
            main_column[i].innerHTML = "";
            main_column[i].appendChild(new_column[i]);
        }
    },
    show_column(class_name) {
        let columns = document.getElementsByClassName(class_name);
        if(columns.length > 0) {
            for(let i = 0; i < columns.length; i++) {
                let column_div = columns[i].getElementsByTagName('div')[0];
                if(column_div) {
                    column_div.removeAttribute('style');
                    // columns[i].removeAttribute('style');
                    // columns[i].classList.add('column-visible');
                    column_div.classList.remove('right_fade');
                    column_div.classList.remove('left_fade');
                    column_div.style.WebkitAnimation = "left_fade_in";
                    column_div.style.animation = 'left_fade_in';
                    column_div.style.animationDuration = "1s";
                }
            }
        }
    },
    move_column(class_name, distance) {
        let columns = document.getElementsByClassName(class_name);
        if(columns.length > 0) {
            for(let i = 0; i < columns.length; i++) {
                let column_div = columns[i].getElementsByTagName('div')[0];
                column_div.style.transform = "translateX(" + distance + "px)"
                // console.log("Moving ")
            }
        }
    }
}